// Type Imports
import type { ThemePreset } from '@/types/theme'

export const themePresets = {
  caffeine: {
    label: 'Caffeine',
    styles: {
      light: {
        background: 'oklch(0.98 0 0)',
        foreground: 'oklch(0.24 0 0)',
        card: 'oklch(0.99 0 0)',
        'card-foreground': 'oklch(0.24 0 0)',
        popover: 'oklch(0.99 0 0)',
        'popover-foreground': 'oklch(0.24 0 0)',
        primary: 'oklch(0.43 0.04 41.99)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.92 0.07 74.37)',
        'secondary-foreground': 'oklch(0.35 0.07 40.83)',
        muted: 'oklch(0.95 0 0)',
        'muted-foreground': 'oklch(0.50 0 0)',
        accent: 'oklch(0.93 0 0)',
        'accent-foreground': 'oklch(0.24 0 0)',
        destructive: 'oklch(0.63 0.19 33.34)',
        border: 'oklch(0.88 0 0)',
        input: 'oklch(0.88 0 0)',
        ring: 'oklch(0.43 0.04 41.99)',
        'chart-1': 'oklch(0.43 0.04 41.99)',
        'chart-2': 'oklch(0.92 0.07 74.37)',
        'chart-3': 'oklch(0.93 0 0)',
        'chart-4': 'oklch(0.94 0.05 75.50)',
        'chart-5': 'oklch(0.43 0.04 41.67)',
        sidebar: 'oklch(0.99 0 0)',
        'sidebar-foreground': 'oklch(0.26 0 0)',
        'sidebar-primary': 'oklch(0.33 0 0)',
        'sidebar-primary-foreground': 'oklch(0.99 0 0)',
        'sidebar-accent': 'oklch(0.98 0 0)',
        'sidebar-accent-foreground': 'oklch(0.33 0 0)',
        'sidebar-border': 'oklch(0.94 0 0)',
        'sidebar-ring': 'oklch(0.77 0 0)'
      },
      dark: {
        background: 'oklch(0.18 0 0)',
        foreground: 'oklch(0.95 0 0)',
        card: 'oklch(0.21 0 0)',
        'card-foreground': 'oklch(0.95 0 0)',
        popover: 'oklch(0.21 0 0)',
        'popover-foreground': 'oklch(0.95 0 0)',
        primary: 'oklch(0.92 0.05 66.17)',
        'primary-foreground': 'oklch(0.20 0.02 200.20)',
        secondary: 'oklch(0.32 0.02 63.70)',
        'secondary-foreground': 'oklch(0.92 0.05 66.17)',
        muted: 'oklch(0.25 0 0)',
        'muted-foreground': 'oklch(0.77 0 0)',
        accent: 'oklch(0.29 0 0)',
        'accent-foreground': 'oklch(0.95 0 0)',
        destructive: 'oklch(0.63 0.19 33.34)',
        border: 'oklch(0.24 0.01 91.75)',
        input: 'oklch(0.40 0 0)',
        ring: 'oklch(0.92 0.05 66.17)',
        'chart-1': 'oklch(0.92 0.05 66.17)',
        'chart-2': 'oklch(0.32 0.02 63.70)',
        'chart-3': 'oklch(0.29 0 0)',
        'chart-4': 'oklch(0.35 0.02 67.00)',
        'chart-5': 'oklch(0.92 0.05 67.09)',
        sidebar: 'oklch(0.21 0.01 285.89)',
        'sidebar-foreground': 'oklch(0.97 0.00 286.38)',
        'sidebar-primary': 'oklch(0.49 0.22 264.38)',
        'sidebar-primary-foreground': 'oklch(1.00 0 0)',
        'sidebar-accent': 'oklch(0.27 0.01 286.03)',
        'sidebar-accent-foreground': 'oklch(0.97 0.00 286.38)',
        'sidebar-border': 'oklch(0.27 0.01 286.03)',
        'sidebar-ring': 'oklch(0.87 0.01 286.29)'
      }
    }
  },
  claude: {
    label: 'Claude',
    styles: {
      light: {
        background: 'oklch(0.98 0.01 95.10)',
        foreground: 'oklch(0.34 0.03 95.72)',
        card: 'oklch(0.98 0.01 95.10)',
        'card-foreground': 'oklch(0.19 0.00 106.59)',
        popover: 'oklch(1.00 0 0)',
        'popover-foreground': 'oklch(0.27 0.02 98.94)',
        primary: 'oklch(0.62 0.14 39.04)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.92 0.01 92.99)',
        'secondary-foreground': 'oklch(0.43 0.02 98.60)',
        muted: 'oklch(0.955 0.0124 91.52)',
        'muted-foreground': 'oklch(0.61 0.01 97.42)',
        accent: 'oklch(0.92 0.01 92.99)',
        'accent-foreground': 'oklch(0.27 0.02 98.94)',
        destructive: 'oklch(0.19 0.00 106.59)',
        border: 'oklch(0.9078 0.0094 106.59)',
        input: 'oklch(0.76 0.02 98.35)',
        ring: 'oklch(0.59 0.17 253.06)',
        'chart-1': 'oklch(0.56 0.13 43.00)',
        'chart-2': 'oklch(0.69 0.16 290.41)',
        'chart-3': 'oklch(0.88 0.03 93.13)',
        'chart-4': 'oklch(0.88 0.04 298.18)',
        'chart-5': 'oklch(0.56 0.13 42.06)',
        sidebar: 'oklch(0.97 0.01 98.88)',
        'sidebar-foreground': 'oklch(0.36 0.01 106.65)',
        'sidebar-primary': 'oklch(0.62 0.14 39.04)',
        'sidebar-primary-foreground': 'oklch(0.99 0 0)',
        'sidebar-accent': 'oklch(0.9537 0.0118 59.56)',
        'sidebar-accent-foreground': 'oklch(0.33 0 0)',
        'sidebar-border': 'oklch(0.94 0 0)',
        'sidebar-ring': 'oklch(0.77 0 0)'
      },
      dark: {
        background: 'oklch(0.27 0.00 106.64)',
        foreground: 'oklch(0.81 0.01 93.01)',
        card: 'oklch(0.27 0.00 106.64)',
        'card-foreground': 'oklch(0.98 0.01 95.10)',
        popover: 'oklch(0.31 0.00 106.60)',
        'popover-foreground': 'oklch(0.92 0.00 106.48)',
        primary: 'oklch(0.67 0.13 38.76)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.98 0.01 95.10)',
        'secondary-foreground': 'oklch(0.31 0.00 106.60)',
        muted: 'oklch(0.22 0.00 106.71)',
        'muted-foreground': 'oklch(0.77 0.02 99.07)',
        accent: 'oklch(0.21 0.01 95.42)',
        'accent-foreground': 'oklch(0.97 0.01 98.88)',
        destructive: 'oklch(0.64 0.21 25.33)',
        border: 'oklch(0.36 0.01 106.89)',
        input: 'oklch(0.43 0.01 100.22)',
        ring: 'oklch(0.59 0.17 253.06)',
        'chart-1': 'oklch(0.56 0.13 43.00)',
        'chart-2': 'oklch(0.69 0.16 290.41)',
        'chart-3': 'oklch(0.21 0.01 95.42)',
        'chart-4': 'oklch(0.31 0.05 289.32)',
        'chart-5': 'oklch(0.56 0.13 42.06)',
        sidebar: 'oklch(0.24 0.00 67.71)',
        'sidebar-foreground': 'oklch(0.81 0.01 93.01)',
        'sidebar-primary': 'oklch(0.33 0 0)',
        'sidebar-primary-foreground': 'oklch(0.99 0 0)',
        'sidebar-accent': 'oklch(0.17 0.00 106.62)',
        'sidebar-accent-foreground': 'oklch(0.81 0.01 93.01)',
        'sidebar-border': 'oklch(0.94 0 0)',
        'sidebar-ring': 'oklch(0.77 0 0)'
      }
    }
  },
  corporate: {
    label: 'Corporate',
    styles: {
      light: {
        background: 'oklch(0.9555 0.0125 271.28)',
        foreground: 'oklch(0.21 0.03 264.67)',
        card: 'oklch(0.9793 0.0083 271.33)',
        'card-foreground': 'oklch(0.21 0.03 264.67)',
        popover: 'oklch(1.00 0 0)',
        'popover-foreground': 'oklch(0.21 0.03 264.67)',
        primary: 'oklch(0.48 0.20 260.48)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.9142 0.0208 274.02)',
        'secondary-foreground': 'oklch(0.37 0.03 259.73)',
        muted: 'oklch(0.9443 0.0165 274.82)',
        'muted-foreground': 'oklch(0.55 0.02 264.37)',

        accent: 'oklch(0.92 0.02 261.78)',
        'accent-foreground': 'oklch(0.48 0.20 260.48)',
        destructive: 'oklch(0.58 0.22 27.33)',
        border: 'oklch(0.8893 0.0169 259.42)',
        input: 'oklch(0.9002 0.013 266.69)',
        ring: 'oklch(0.48 0.20 260.48)',
        'chart-1': 'oklch(0.48 0.20 260.48)',
        'chart-2': 'oklch(0.56 0.24 260.95)',
        'chart-3': 'oklch(0.40 0.16 259.09)',
        'chart-4': 'oklch(0.43 0.16 259.85)',
        'chart-5': 'oklch(0.29 0.07 260.37)',
        sidebar: 'oklch(0.97 0.00 264.70)',
        'sidebar-foreground': 'oklch(0.21 0.03 264.67)',
        'sidebar-primary': 'oklch(0.48 0.20 260.48)',
        'sidebar-primary-foreground': 'oklch(1.00 0 0)',
        'sidebar-accent': 'oklch(0.95 0.02 261.78)',
        'sidebar-accent-foreground': 'oklch(0.48 0.20 260.48)',
        'sidebar-border': 'oklch(0.93 0.01 264.60)',
        'sidebar-ring': 'oklch(0.48 0.20 260.48)'
      },
      dark: {
        background: 'oklch(0.26 0.03 262.71)',
        foreground: 'oklch(0.93 0.01 264.60)',
        card: 'oklch(0.2938 0.0398 256.22)',
        'card-foreground': 'oklch(0.93 0.01 264.60)',
        popover: 'oklch(0.2938 0.0398 256.22)',
        'popover-foreground': 'oklch(0.93 0.01 264.60)',
        primary: 'oklch(0.56 0.24 260.95)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.35 0.04 262.16)',
        'secondary-foreground': 'oklch(0.93 0.01 264.60)',
        muted: 'oklch(0.30 0.03 261.75)',
        'muted-foreground': 'oklch(0.71 0.02 261.33)',
        accent: 'oklch(0.33 0.04 264.82)',
        'accent-foreground': 'oklch(0.93 0.01 264.60)',
        destructive: 'oklch(0.64 0.21 25.33)',
        border: 'oklch(0.35 0.04 262.16)',
        input: 'oklch(0.35 0.04 262.16)',
        ring: 'oklch(0.56 0.24 260.95)',
        'chart-1': 'oklch(0.56 0.24 260.95)',
        'chart-2': 'oklch(0.48 0.20 260.48)',
        'chart-3': 'oklch(0.69 0.17 256.00)',
        'chart-4': 'oklch(0.43 0.16 259.85)',
        'chart-5': 'oklch(0.29 0.07 260.37)',
        sidebar: 'oklch(0.26 0.03 262.71)',
        'sidebar-foreground': 'oklch(0.93 0.01 264.60)',
        'sidebar-primary': 'oklch(0.56 0.24 260.95)',
        'sidebar-primary-foreground': 'oklch(1.00 0 0)',
        'sidebar-accent': 'oklch(0.33 0.04 264.82)',
        'sidebar-accent-foreground': 'oklch(0.93 0.01 264.60)',
        'sidebar-border': 'oklch(0.35 0.04 262.16)',
        'sidebar-ring': 'oklch(0.56 0.24 260.95)'
      }
    }
  },
  'ghibli-studio': {
    label: 'Ghibli Studio',
    styles: {
      light: {
        background: 'oklch(0.91 0.05 82.69)',
        foreground: 'oklch(0.41 0.08 79.04)',
        card: 'oklch(0.92 0.04 83.86)',
        'card-foreground': 'oklch(0.41 0.08 73.75)',
        popover: 'oklch(0.92 0.04 83.86)',
        'popover-foreground': 'oklch(0.41 0.08 73.75)',
        primary: 'oklch(0.71 0.10 111.99)',
        'primary-foreground': 'oklch(0.98 0.01 3.71)',
        secondary: 'oklch(0.88 0.05 83.41)',
        'secondary-foreground': 'oklch(0.51 0.08 79.21)',
        muted: 'oklch(0.86 0.06 83.48)',
        'muted-foreground': 'oklch(0.51 0.08 74.26)',
        accent: 'oklch(0.86 0.05 84.50)',
        'accent-foreground': 'oklch(0.26 0.02 358.42)',
        destructive: 'oklch(0.63 0.24 29.21)',
        border: 'oklch(0.74 0.06 79.81)',
        input: 'oklch(0.74 0.06 79.81)',
        ring: 'oklch(0.51 0.08 74.26)',
        'chart-1': 'oklch(0.66 0.19 41.68)',
        'chart-2': 'oklch(0.70 0.12 183.20)',
        'chart-3': 'oklch(0.48 0.08 211.46)',
        'chart-4': 'oklch(0.84 0.17 85.07)',
        'chart-5': 'oklch(0.74 0.17 60.21)',
        sidebar: 'oklch(0.87 0.06 83.96)',
        'sidebar-foreground': 'oklch(0.41 0.08 79.04)',
        'sidebar-primary': 'oklch(0.26 0.02 358.42)',
        'sidebar-primary-foreground': 'oklch(0.98 0.01 3.71)',
        'sidebar-accent': 'oklch(0.83 0.06 84.46)',
        'sidebar-accent-foreground': 'oklch(0.26 0.02 358.42)',
        'sidebar-border': 'oklch(0.91 0.00 0.43)',
        'sidebar-ring': 'oklch(0.71 0.00 0.37)'
      },
      dark: {
        background: 'oklch(0.20 0.01 48.35)',
        foreground: 'oklch(0.88 0.05 79.26)',
        card: 'oklch(0.25 0.01 56.14)',
        'card-foreground': 'oklch(0.88 0.05 79.26)',
        popover: 'oklch(0.25 0.01 56.14)',
        'popover-foreground': 'oklch(0.88 0.05 79.26)',
        primary: 'oklch(0.64 0.05 115.39)',
        'primary-foreground': 'oklch(0.98 0.01 3.71)',
        secondary: 'oklch(0.33 0.02 60.70)',
        'secondary-foreground': 'oklch(0.88 0.05 83.41)',
        muted: 'oklch(0.27 0.01 39.35)',
        'muted-foreground': 'oklch(0.74 0.06 79.81)',
        accent: 'oklch(0.33 0.02 60.70)',
        'accent-foreground': 'oklch(0.86 0.05 84.50)',
        destructive: 'oklch(0.63 0.24 29.21)',
        border: 'oklch(0.33 0.02 60.70)',
        input: 'oklch(0.33 0.02 60.70)',
        ring: 'oklch(0.64 0.05 115.39)',
        'chart-1': 'oklch(0.66 0.19 41.68)',
        'chart-2': 'oklch(0.70 0.12 183.20)',
        'chart-3': 'oklch(0.48 0.08 211.46)',
        'chart-4': 'oklch(0.84 0.17 85.07)',
        'chart-5': 'oklch(0.74 0.17 60.21)',
        sidebar: 'oklch(0.23 0.01 56.09)',
        'sidebar-foreground': 'oklch(0.88 0.05 79.26)',
        'sidebar-primary': 'oklch(0.64 0.05 115.39)',
        'sidebar-primary-foreground': 'oklch(0.98 0.01 3.71)',
        'sidebar-accent': 'oklch(0.33 0.02 60.70)',
        'sidebar-accent-foreground': 'oklch(0.86 0.05 84.50)',
        'sidebar-border': 'oklch(0.33 0.02 60.70)',
        'sidebar-ring': 'oklch(0.64 0.05 115.39)'
      }
    }
  },
  marvel: {
    label: 'Marvel',
    styles: {
      light: {
        background: 'oklch(0.98 0.01 25.23)',
        foreground: 'oklch(0.23 0.08 24.25)',
        card: 'oklch(0.95 0.02 24.79)',
        'card-foreground': 'oklch(0.18 0.01 29.18)',
        popover: 'oklch(0.94 0.01 25.23)',
        'popover-foreground': 'oklch(0.22 0.01 29.09)',
        primary: 'oklch(0.55 0.22 27.03)',
        'primary-foreground': 'oklch(0.98 0.01 100.72)',
        secondary: 'oklch(0.52 0.14 247.51)',
        'secondary-foreground': 'oklch(0.98 0.01 100.72)',
        muted: 'oklch(0.94 0.02 26.09)',
        'muted-foreground': 'oklch(0.45 0.02 18.12)',
        accent: 'oklch(0.86 0.04 33.03)',
        'accent-foreground': 'oklch(0.18 0.01 29.18)',
        destructive: 'oklch(0.56 0.23 29.23)',
        border: 'oklch(0.9 0.03 25.3)',
        input: 'oklch(0.80 0.01 25.22)',
        ring: 'oklch(0.50 0.12 244.86)',
        'chart-1': 'oklch(0.58 0.23 27.06)',
        'chart-2': 'oklch(0.61 0.18 251.95)',
        'chart-3': 'oklch(0.72 0.15 83.96)',
        'chart-4': 'oklch(0.67 0.15 144.89)',
        'chart-5': 'oklch(0.75 0.15 304.74)',
        sidebar: 'oklch(0.97 0 0)',
        'sidebar-foreground': 'oklch(0.20 0.01 18.05)',
        'sidebar-primary': 'oklch(0.52 0.14 247.51)',
        'sidebar-primary-foreground': 'oklch(0.98 0.01 100.72)',
        'sidebar-accent': 'oklch(0.69 0.14 79.64)',
        'sidebar-accent-foreground': 'oklch(0.20 0.01 18.05)',
        'sidebar-border': 'oklch(0.87 0.01 25.23)',
        'sidebar-ring': 'oklch(0.52 0.14 247.51)',
        'shadow-color': 'oklch(0 0 0 / 0.01)',
        'shadow-opacity': '0.01',
        'shadow-blur': '3px',
        'shadow-spread': '0px',
        'shadow-offset-x': '0px',
        'shadow-offset-y': '1px'
      },
      dark: {
        background: 'oklch(0.1744 0.0088 31.22)',
        foreground: 'oklch(0.95 0.01 25.23)',
        card: 'oklch(0.2177 0.0067 34.3)',
        'card-foreground': 'oklch(0.95 0.01 25.23)',
        popover: 'oklch(0.18 0.01 29.18)',
        'popover-foreground': 'oklch(0.95 0.01 25.23)',
        primary: 'oklch(0.5502 0.22 27.03)',
        'primary-foreground': 'oklch(0.98 0.01 100.72)',
        secondary: 'oklch(0.50 0.14 249.16)',
        'secondary-foreground': 'oklch(0.98 0.01 100.72)',
        muted: 'oklch(0.20 0.01 18.05)',
        'muted-foreground': 'oklch(0.70 0.01 25.22)',
        accent: 'oklch(0.59 0.12 78.11)',
        'accent-foreground': 'oklch(0.95 0.01 25.23)',
        destructive: 'oklch(0.56 0.23 29.23)',
        border: 'oklch(0.3235 0.0086 17.61)',
        input: 'oklch(0.38 0.01 17.71)',
        ring: 'oklch(0.49 0.14 250.75)',
        'chart-1': 'oklch(0.64 0.25 26.85)',
        'chart-2': 'oklch(0.66 0.19 250.17)',
        'chart-3': 'oklch(0.78 0.16 87.01)',
        'chart-4': 'oklch(0.68 0.15 144.94)',
        'chart-5': 'oklch(0.75 0.15 304.74)',
        sidebar: 'oklch(0.14 0.01 33.25)',
        'sidebar-foreground': 'oklch(0.95 0.01 25.23)',
        'sidebar-primary': 'oklch(0.50 0.14 249.16)',
        'sidebar-primary-foreground': 'oklch(0.98 0.01 100.72)',
        'sidebar-accent': 'oklch(0.59 0.12 78.11)',
        'sidebar-accent-foreground': 'oklch(0.95 0.01 25.23)',
        'sidebar-border': 'oklch(0.32 0.01 27.45 / 30%)',
        'sidebar-ring': 'oklch(0.50 0.14 249.16)',
        'shadow-color': 'oklch(0 0 0 / 0.01)',
        'shadow-opacity': '0.01',
        'shadow-blur': '3px',
        'shadow-spread': '0px',
        'shadow-offset-x': '0px',
        'shadow-offset-y': '1px'
      }
    }
  },
  'material-design': {
    label: 'Material Design',
    styles: {
      light: {
        background: 'oklch(0.98 0.01 334.35)',
        foreground: 'oklch(0.22 0 0)',
        card: 'oklch(0.96 0.01 335.69)',
        'card-foreground': 'oklch(0.14 0 0)',
        popover: 'oklch(0.95 0.01 316.67)',
        'popover-foreground': 'oklch(0.40 0.04 309.35)',
        primary: 'oklch(0.51 0.21 286.50)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.49 0.04 300.23)',
        'secondary-foreground': 'oklch(1.00 0 0)',
        muted: 'oklch(0.96 0.01 335.69)',
        'muted-foreground': 'oklch(0.14 0 0)',
        accent: 'oklch(0.92 0.04 303.47)',
        'accent-foreground': 'oklch(0.14 0 0)',
        destructive: 'oklch(0.57 0.23 29.21)',
        border: 'oklch(0.83 0.02 308.26)',
        input: 'oklch(0.57 0.02 309.68)',
        ring: 'oklch(0.50 0.13 293.77)',
        'chart-1': 'oklch(0.61 0.21 279.42)',
        'chart-2': 'oklch(0.72 0.15 157.67)',
        'chart-3': 'oklch(0.66 0.17 324.24)',
        'chart-4': 'oklch(0.81 0.15 127.91)',
        'chart-5': 'oklch(0.68 0.17 258.25)',
        sidebar: 'oklch(0.99 0 0)',
        'sidebar-foreground': 'oklch(0.15 0 0)',
        'sidebar-primary': 'oklch(0.56 0.11 228.27)',
        'sidebar-primary-foreground': 'oklch(0.98 0 0)',
        'sidebar-accent': 'oklch(0.95 0 0)',
        'sidebar-accent-foreground': 'oklch(0.25 0 0)',
        'sidebar-border': 'oklch(0.90 0 0)',
        'sidebar-ring': 'oklch(0.56 0.11 228.27)',
        'shadow-color': 'oklch(0 0 0 / 0.01)',
        'shadow-opacity': '0.01',
        'shadow-blur': '3px',
        'shadow-spread': '0px',
        'shadow-offset-x': '0px',
        'shadow-offset-y': '1px'
      },
      dark: {
        background: 'oklch(0.15 0.01 317.69)',
        foreground: 'oklch(0.95 0.01 321.50)',
        card: 'oklch(0.22 0.02 322.13)',
        'card-foreground': 'oklch(0.95 0.01 321.50)',
        popover: 'oklch(0.22 0.02 322.13)',
        'popover-foreground': 'oklch(0.95 0.01 321.50)',
        primary: 'oklch(0.60 0.22 279.81)',
        'primary-foreground': 'oklch(0.98 0.01 321.51)',
        secondary: 'oklch(0.45 0.03 294.79)',
        'secondary-foreground': 'oklch(0.95 0.01 321.50)',
        muted: 'oklch(0.22 0.01 319.50)',
        'muted-foreground': 'oklch(0.70 0.01 320.70)',
        accent: 'oklch(0.35 0.06 299.57)',
        'accent-foreground': 'oklch(0.95 0.01 321.50)',
        destructive: 'oklch(0.57 0.23 29.21)',
        border: 'oklch(0.40 0.04 309.35)',
        input: 'oklch(0.40 0.04 309.35)',
        ring: 'oklch(0.50 0.15 294.97)',
        'chart-1': 'oklch(0.50 0.25 274.99)',
        'chart-2': 'oklch(0.60 0.15 150.16)',
        'chart-3': 'oklch(0.65 0.20 309.96)',
        'chart-4': 'oklch(0.60 0.17 132.98)',
        'chart-5': 'oklch(0.60 0.20 255.25)',
        sidebar: 'oklch(0.20 0.01 317.74)',
        'sidebar-foreground': 'oklch(0.95 0.01 321.50)',
        'sidebar-primary': 'oklch(0.59 0.11 225.82)',
        'sidebar-primary-foreground': 'oklch(0.95 0.01 321.50)',
        'sidebar-accent': 'oklch(0.30 0.01 319.52)',
        'sidebar-accent-foreground': 'oklch(0.95 0.01 321.50)',
        'sidebar-border': 'oklch(0.35 0.01 319.53 / 30%)',
        'sidebar-ring': 'oklch(0.59 0.11 225.82)',
        'shadow-color': 'oklch(0 0 0 / 0.01)',
        'shadow-opacity': '0.01',
        'shadow-blur': '3px',
        'shadow-spread': '0px',
        'shadow-offset-x': '0px',
        'shadow-offset-y': '1px'
      }
    }
  },
  'modern-minimal': {
    label: 'Modern Minimal',
    styles: {
      light: {
        background: 'oklch(1.00 0 0)',
        foreground: 'oklch(0.32 0 0)',
        card: 'oklch(1.00 0 0)',
        'card-foreground': 'oklch(0.32 0 0)',
        popover: 'oklch(1.00 0 0)',
        'popover-foreground': 'oklch(0.32 0 0)',
        primary: 'oklch(0.62 0.19 259.76)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.97 0 0)',
        'secondary-foreground': 'oklch(0.45 0.03 257.68)',
        muted: 'oklch(0.98 0 0)',
        'muted-foreground': 'oklch(0.55 0.02 264.41)',
        accent: 'oklch(0.95 0.03 233.56)',
        'accent-foreground': 'oklch(0.38 0.14 265.59)',
        destructive: 'oklch(0.64 0.21 25.39)',
        border: 'oklch(0.93 0.01 261.82)',
        input: 'oklch(0.93 0.01 261.82)',
        ring: 'oklch(0.62 0.19 259.76)',
        'chart-1': 'oklch(0.62 0.19 259.76)',
        'chart-2': 'oklch(0.55 0.22 262.96)',
        'chart-3': 'oklch(0.49 0.22 264.43)',
        'chart-4': 'oklch(0.42 0.18 265.55)',
        'chart-5': 'oklch(0.38 0.14 265.59)',
        sidebar: 'oklch(0.98 0 0)',
        'sidebar-foreground': 'oklch(0.14 0 0)',
        'sidebar-primary': 'oklch(0.20 0 0)',
        'sidebar-primary-foreground': 'oklch(0.98 0 0)',
        'sidebar-accent': 'oklch(0.97 0 0)',
        'sidebar-accent-foreground': 'oklch(0.20 0 0)',
        'sidebar-border': 'oklch(0.92 0 0)',
        'sidebar-ring': 'oklch(0.71 0 0)'
      },
      dark: {
        background: 'oklch(0.20 0 0)',
        foreground: 'oklch(0.92 0 0)',
        card: 'oklch(0.27 0 0)',
        'card-foreground': 'oklch(0.92 0 0)',
        popover: 'oklch(0.27 0 0)',
        'popover-foreground': 'oklch(0.92 0 0)',
        primary: 'oklch(0.62 0.19 259.76)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.27 0 0)',
        'secondary-foreground': 'oklch(0.92 0 0)',
        muted: 'oklch(0.27 0 0)',
        'muted-foreground': 'oklch(0.72 0 0)',
        accent: 'oklch(0.38 0.14 265.59)',
        'accent-foreground': 'oklch(0.88 0.06 254.63)',
        destructive: 'oklch(0.64 0.21 25.39)',
        border: 'oklch(0.37 0 0)',
        input: 'oklch(0.37 0 0)',
        ring: 'oklch(0.62 0.19 259.76)',
        'chart-1': 'oklch(0.71 0.14 254.69)',
        'chart-2': 'oklch(0.62 0.19 259.76)',
        'chart-3': 'oklch(0.55 0.22 262.96)',
        'chart-4': 'oklch(0.49 0.22 264.43)',
        'chart-5': 'oklch(0.42 0.18 265.55)',
        sidebar: 'oklch(0.21 0.01 285.93)',
        'sidebar-foreground': 'oklch(0.99 0 0)',
        'sidebar-primary': 'oklch(0.49 0.24 264.40)',
        'sidebar-primary-foreground': 'oklch(0.99 0 0)',
        'sidebar-accent': 'oklch(0.27 0.01 286.10)',
        'sidebar-accent-foreground': 'oklch(0.99 0 0)',
        'sidebar-border': 'oklch(1.00 0 0 / 10%)',
        'sidebar-ring': 'oklch(0.55 0.02 285.93)'
      }
    }
  },
  nature: {
    label: 'Nature',
    styles: {
      light: {
        background: 'oklch(0.97 0.01 87.41)',
        foreground: 'oklch(0.31 0.02 148.72)',
        card: 'oklch(0.97 0.01 87.41)',
        'card-foreground': 'oklch(0.30 0.04 29.20)',
        popover: 'oklch(0.97 0.01 87.41)',
        'popover-foreground': 'oklch(0.30 0.04 29.20)',
        primary: 'oklch(0.52 0.13 144.33)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.96 0.02 147.54)',
        'secondary-foreground': 'oklch(0.43 0.12 144.33)',
        muted: 'oklch(0.94 0.01 72.65)',
        'muted-foreground': 'oklch(0.50 0.01 153.49)',
        accent: 'oklch(0.90 0.05 146.01)',
        'accent-foreground': 'oklch(0.43 0.12 144.33)',
        destructive: 'oklch(0.54 0.19 26.90)',
        border: 'oklch(0.88 0 0)',
        input: 'oklch(0.88 0.02 77.29)',
        ring: 'oklch(0.52 0.13 144.33)',
        'chart-1': 'oklch(0.67 0.16 144.06)',
        'chart-2': 'oklch(0.58 0.14 144.14)',
        'chart-3': 'oklch(0.52 0.13 144.33)',
        'chart-4': 'oklch(0.43 0.12 144.33)',
        'chart-5': 'oklch(0.22 0.05 145.34)',
        sidebar: 'oklch(0.94 0.01 72.65)',
        'sidebar-foreground': 'oklch(0.30 0.04 29.20)',
        'sidebar-primary': 'oklch(0.52 0.13 144.33)',
        'sidebar-primary-foreground': 'oklch(1.00 0 0)',
        'sidebar-accent': 'oklch(0.90 0.05 146.01)',
        'sidebar-accent-foreground': 'oklch(0.43 0.12 144.33)',
        'sidebar-border': 'oklch(0.88 0.02 77.29)',
        'sidebar-ring': 'oklch(0.52 0.13 144.33)'
      },
      dark: {
        background: 'oklch(0.31 0.03 150.45)',
        foreground: 'oklch(0.84 0.01 145.33)',
        card: 'oklch(0.35 0.03 149.75)',
        'card-foreground': 'oklch(0.84 0.01 145.33)',
        popover: 'oklch(0.33 0.03 146.53)',
        'popover-foreground': 'oklch(0.94 0.01 72.65)',
        primary: 'oklch(0.67 0.16 144.06)',
        'primary-foreground': 'oklch(0.99 0.02 145.33)',
        secondary: 'oklch(0.39 0.03 143.09)',
        'secondary-foreground': 'oklch(0.90 0.02 142.94)',
        muted: 'oklch(0.29 0.03 147.05)',
        'muted-foreground': 'oklch(0.69 0.02 150.35)',
        accent: 'oklch(0.58 0.14 144.14)',
        'accent-foreground': 'oklch(0.94 0.01 72.65)',
        destructive: 'oklch(0.54 0.19 26.90)',
        border: 'oklch(0.39 0.03 143.09)',
        input: 'oklch(0.39 0.03 143.09)',
        ring: 'oklch(0.67 0.16 144.06)',
        'chart-1': 'oklch(0.77 0.12 145.23)',
        'chart-2': 'oklch(0.72 0.14 144.92)',
        'chart-3': 'oklch(0.67 0.16 144.06)',
        'chart-4': 'oklch(0.63 0.15 144.32)',
        'chart-5': 'oklch(0.58 0.14 144.14)',
        sidebar: 'oklch(0.27 0.03 150.18)',
        'sidebar-foreground': 'oklch(0.94 0.01 72.65)',
        'sidebar-primary': 'oklch(0.67 0.16 144.06)',
        'sidebar-primary-foreground': 'oklch(0.22 0.05 145.34)',
        'sidebar-accent': 'oklch(0.58 0.14 144.14)',
        'sidebar-accent-foreground': 'oklch(0.94 0.01 72.65)',
        'sidebar-border': 'oklch(0.39 0.03 143.09)',
        'sidebar-ring': 'oklch(0.67 0.16 144.06)'
      }
    }
  },
  perplexity: {
    label: 'Perplexity',
    styles: {
      light: {
        background: 'oklch(0.9611 0.0085 197.02)',
        foreground: 'oklch(0.38 0.06 212.65)',
        card: 'oklch(0.9791 0.0042 197.09)',
        'card-foreground': 'oklch(0.38 0.06 212.65)',
        popover: 'oklch(0.97 0.01 196.73)',
        'popover-foreground': 'oklch(0.38 0.06 212.65)',
        primary: 'oklch(0.72 0.12 209.78)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.97 0.01 247.86)',
        'secondary-foreground': 'oklch(0.14 0.00 285.86)',
        muted: 'oklch(0.9356 0.0107 196.97)',
        'muted-foreground': 'oklch(0.55 0.04 257.42)',
        accent: 'oklch(0.9212 0.0193 204.84)',
        'accent-foreground': 'oklch(0.57 0.10 213.38)',
        destructive: 'oklch(0.64 0.21 25.33)',
        border: 'oklch(0.93 0.01 255.51)',
        input: 'oklch(0.93 0.01 255.51)',

        ring: 'oklch(0.620 0.12 209.78)',
        'chart-1': 'oklch(0.72 0.12 209.78)',
        'chart-2': 'oklch(0.57 0.10 213.38)',
        'chart-3': 'oklch(0.79 0.12 208.87)',
        'chart-4': 'oklch(0.76 0.11 208.84)',
        'chart-5': 'oklch(0.83 0.10 208.33)',
        sidebar: 'oklch(0.98 0.00 247.80)',
        'sidebar-foreground': 'oklch(0.14 0.00 285.86)',
        'sidebar-primary': 'oklch(0.72 0.12 209.78)',
        'sidebar-primary-foreground': 'oklch(1.00 0 0)',
        'sidebar-accent': 'oklch(0.96 0.02 205.23)',
        'sidebar-accent-foreground': 'oklch(0.57 0.10 213.38)',
        'sidebar-border': 'oklch(0.93 0.01 255.51)',
        'sidebar-ring': 'oklch(0.72 0.12 209.78)'
      },
      dark: {
        background: 'oklch(0.21 0.02 224.44)',
        foreground: 'oklch(0.8107 0.0396 226.16)',
        card: 'oklch(0.23 0.03 216.05)',
        'card-foreground': 'oklch(0.702 0.0417 225.62)',
        popover: 'oklch(0.23 0.03 216.05)',
        'popover-foreground': 'oklch(0.9369 0.049 196.35)',
        primary: 'oklch(0.72 0.12 209.78)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.27 0.01 286.10)',
        'secondary-foreground': 'oklch(0.97 0.00 264.70)',
        muted: 'oklch(0.1843 0.0157 227.35)',
        'muted-foreground': 'oklch(0.5814 0.0301 223.57)',
        accent: 'oklch(0.1694 0.0235 210.7)',
        'accent-foreground': 'oklch(0.97 0.00 264.70)',
        destructive: 'oklch(0.64 0.21 25.33)',
        border: 'oklch(0.3611 0.0177 213.28)',
        input: 'oklch(0.29 0.00 286.27)',
        ring: 'oklch(0.72 0.12 209.78)',
        'chart-1': 'oklch(0.72 0.12 209.78)',
        'chart-2': 'oklch(0.79 0.12 208.87)',
        'chart-3': 'oklch(0.76 0.11 208.84)',
        'chart-4': 'oklch(0.83 0.10 208.33)',
        'chart-5': 'oklch(0.57 0.10 213.38)',
        sidebar: 'oklch(0.19 0 0)',
        'sidebar-foreground': 'oklch(0.97 0.00 264.70)',
        'sidebar-primary': 'oklch(0.72 0.12 209.78)',
        'sidebar-primary-foreground': 'oklch(1.00 0 0)',
        'sidebar-accent': 'oklch(0.24 0.00 286.20)',
        'sidebar-accent-foreground': 'oklch(0.97 0.00 264.70)',
        'sidebar-border': 'oklch(0.29 0.00 286.27)',
        'sidebar-ring': 'oklch(0.72 0.12 209.78)'
      }
    }
  },
  slack: {
    label: 'Slack',
    styles: {
      light: {
        background: 'oklch(1.00 0 0)',
        foreground: 'oklch(0.23 0.00 325.86)',
        card: 'oklch(0.98 0 0)',
        'card-foreground': 'oklch(0.23 0.00 325.86)',
        popover: 'oklch(0.98 0 0)',
        'popover-foreground': 'oklch(0.23 0.00 325.86)',
        primary: 'oklch(0.37 0.14 323.23)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.96 0.01 312.56)',
        'secondary-foreground': 'oklch(0.31 0.11 327.07)',
        muted: 'oklch(0.97 0.00 264.70)',
        'muted-foreground': 'oklch(0.49 0 0)',
        accent: 'oklch(0.88 0.02 323.34)',
        'accent-foreground': 'oklch(0.31 0.11 327.07)',
        destructive: 'oklch(0.59 0.22 11.50)',
        border: 'oklch(0.91 0 0)',
        input: 'oklch(0.91 0 0)',
        ring: 'oklch(0.37 0.14 323.23)',
        'chart-1': 'oklch(0.31 0.11 327.07)',
        'chart-2': 'oklch(0.37 0.14 323.23)',
        'chart-3': 'oklch(0.59 0.22 11.50)',
        'chart-4': 'oklch(0.77 0.13 223.19)',
        'chart-5': 'oklch(0.69 0.14 160.23)',
        sidebar: 'oklch(0.96 0.01 312.56)',
        'sidebar-foreground': 'oklch(0.23 0.00 325.86)',
        'sidebar-primary': 'oklch(0.37 0.14 323.23)',
        'sidebar-primary-foreground': 'oklch(1.00 0 0)',
        'sidebar-accent': 'oklch(0.88 0.02 323.34)',
        'sidebar-accent-foreground': 'oklch(0.31 0.11 327.07)',
        'sidebar-border': 'oklch(0.91 0 0)',
        'sidebar-ring': 'oklch(0.37 0.14 323.23)'
      },
      dark: {
        background: 'oklch(0.23 0.01 255.60)',
        foreground: 'oklch(0.93 0 0)',
        card: 'oklch(0.26 0.01 255.58)',
        'card-foreground': 'oklch(0.93 0 0)',
        popover: 'oklch(0.2298 0.0107 260.68)',
        'popover-foreground': 'oklch(0.93 0 0)',
        primary: 'oklch(0.58 0.14 327.21)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.30 0.01 248.05)',
        'secondary-foreground': 'oklch(0.93 0 0)',
        muted: 'oklch(0.26 0.01 255.58)',
        'muted-foreground': 'oklch(0.68 0 0)',
        accent: 'oklch(0.33 0.03 326.23)',
        'accent-foreground': 'oklch(0.93 0 0)',
        destructive: 'oklch(0.59 0.22 11.50)',
        border: 'oklch(0.30 0.01 268.37)',
        input: 'oklch(0.30 0.01 268.37)',
        ring: 'oklch(0.58 0.14 327.21)',
        'chart-1': 'oklch(0.58 0.14 327.21)',
        'chart-2': 'oklch(0.77 0.13 223.19)',
        'chart-3': 'oklch(0.69 0.14 160.23)',
        'chart-4': 'oklch(0.59 0.22 11.50)',
        'chart-5': 'oklch(0.80 0.15 82.64)',
        sidebar: 'oklch(0.23 0.01 255.60)',
        'sidebar-foreground': 'oklch(0.93 0 0)',
        'sidebar-primary': 'oklch(0.58 0.14 327.21)',
        'sidebar-primary-foreground': 'oklch(1.00 0 0)',
        'sidebar-accent': 'oklch(0.33 0.03 326.23)',
        'sidebar-accent-foreground': 'oklch(0.93 0 0)',
        'sidebar-border': 'oklch(0.30 0.01 268.37)',
        'sidebar-ring': 'oklch(0.58 0.14 327.21)'
      }
    }
  },
  'pastel-dreams': {
    label: 'Pastel Dreams',
    styles: {
      light: {
        background: 'oklch(0.97 0.01 314.78)',
        foreground: 'oklch(0.37 0.03 259.73)',
        card: 'oklch(1.00 0 0)',
        'card-foreground': 'oklch(0.37 0.03 259.73)',
        popover: 'oklch(1.00 0 0)',
        'popover-foreground': 'oklch(0.37 0.03 259.73)',
        primary: 'oklch(0.71 0.16 293.54)',
        'primary-foreground': 'oklch(1.00 0 0)',
        secondary: 'oklch(0.91 0.05 306.09)',
        'secondary-foreground': 'oklch(0.45 0.03 256.80)',
        muted: 'oklch(0.95 0.03 307.17)',
        'muted-foreground': 'oklch(0.55 0.02 264.36)',
        accent: 'oklch(0.94 0.03 321.94)',
        'accent-foreground': 'oklch(0.37 0.03 259.73)',
        destructive: 'oklch(0.81 0.10 19.57)',
        border: 'oklch(0.91 0.05 306.09)',
        input: 'oklch(0.91 0.05 306.09)',

        ring: 'oklch(0.650 0.16 293.54)',
        'chart-1': 'oklch(0.71 0.16 293.54)',
        'chart-2': 'oklch(0.61 0.22 292.72)',
        'chart-3': 'oklch(0.54 0.25 293.01)',
        'chart-4': 'oklch(0.49 0.24 292.58)',
        'chart-5': 'oklch(0.43 0.21 292.76)',
        sidebar: 'oklch(0.91 0.05 306.09)',
        'sidebar-foreground': 'oklch(0.37 0.03 259.73)',
        'sidebar-primary': 'oklch(0.71 0.16 293.54)',
        'sidebar-primary-foreground': 'oklch(1.00 0 0)',
        'sidebar-accent': 'oklch(0.94 0.03 321.94)',
        'sidebar-accent-foreground': 'oklch(0.37 0.03 259.73)',
        'sidebar-border': 'oklch(0.91 0.05 306.09)',
        'sidebar-ring': 'oklch(0.71 0.16 293.54)',
        'shadow-color': 'hsl(0 0% 0%)',
        'shadow-opacity': '0.08',
        'shadow-blur': '16px',
        'shadow-spread': '-4px',
        'shadow-offset-x': '0px',
        'shadow-offset-y': '8px'
      },
      dark: {
        background: 'oklch(0.22 0.01 56.04)',
        foreground: 'oklch(0.93 0.03 272.79)',
        card: 'oklch(0.28 0.03 307.23)',
        'card-foreground': 'oklch(0.93 0.03 272.79)',
        popover: 'oklch(0.28 0.03 307.23)',
        'popover-foreground': 'oklch(0.93 0.03 272.79)',
        primary: 'oklch(0.79 0.12 295.75)',
        'primary-foreground': 'oklch(0.22 0.01 56.04)',
        secondary: 'oklch(0.34 0.04 308.85)',
        'secondary-foreground': 'oklch(0.87 0.01 258.34)',
        muted: 'oklch(0.28 0.03 307.23)',
        'muted-foreground': 'oklch(0.71 0.02 261.32)',
        accent: 'oklch(0.39 0.05 304.64)',
        'accent-foreground': 'oklch(0.87 0.01 258.34)',
        destructive: 'oklch(0.81 0.10 19.57)',
        border: 'oklch(0.34 0.04 308.85)',
        input: 'oklch(0.34 0.04 308.85)',
        ring: 'oklch(0.79 0.12 295.75)',
        'chart-1': 'oklch(0.79 0.12 295.75)',
        'chart-2': 'oklch(0.71 0.16 293.54)',
        'chart-3': 'oklch(0.61 0.22 292.72)',
        'chart-4': 'oklch(0.54 0.25 293.01)',
        'chart-5': 'oklch(0.49 0.24 292.58)',
        sidebar: 'oklch(0.34 0.04 308.85)',
        'sidebar-foreground': 'oklch(0.93 0.03 272.79)',
        'sidebar-primary': 'oklch(0.79 0.12 295.75)',
        'sidebar-primary-foreground': 'oklch(0.22 0.01 56.04)',
        'sidebar-accent': 'oklch(0.39 0.05 304.64)',
        'sidebar-accent-foreground': 'oklch(0.87 0.01 258.34)',
        'sidebar-border': 'oklch(0.34 0.04 308.85)',
        'sidebar-ring': 'oklch(0.79 0.12 295.75)'
      }
    }
  }
} satisfies Record<string, ThemePreset>

export type ThemePresetKey = 'default' | keyof typeof themePresets
